export enum DataTableColumnType {
    DATE = 'date',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    CUSTOM = 'custom',
    ACTIONS = 'actions',
    DATETIME = 'datetime',
    EMAIL = 'email',
    LINK = 'link',
    TAG = 'tag',
    AVATAR = 'avatar',
    ICON = 'icon',
    PHONE = 'phone',
    CODE = 'code',
    PERCENT = 'percent',
    JSON = 'json',
    ARRAY = 'array',
    MODAL = 'modal',
    ROLE = 'role',
    STATUS = 'status',
    ELLIPSIS = 'ellipsis',
    CHECKBOX = 'checkbox',
    WRAP = 'wrap'
}
